// GENERATED — DO NOT HAND-EDIT.
//
// Source of truth: specs/tier-05-experience/widget-instance.entity-hint.yaml
// Generator: tools/v2-gen/v2gen.py
// Regenerate via: make v2-generate-screens
//
// Hand-edits to non-override-block content WILL be lost on next
// regeneration. See specs/_product/dashboard-v2-page-generator.md §5
// for override blocks (imports / helpers / header-actions).

import type { ListPageConfig } from "../../components/composition/ListPage";
import { widgetInstancesApi } from "../../api/widget-instances";
import type { WidgetInstance } from "../../api/types";
// override-block:imports BEGIN
// CHG-2460 / ITER-905202 — Widget Studio S3. `widget_family` (forward-promised
// WidgetDefinition.family join projection) and `registration_status` render as
// single chips; `chip` is not a built-in DataTable cell type so the generator
// emits a `custom` column bound to a render helper here. Design-system tokens
// only — no hardcoded color (composition-lint).
import { createElement } from "react";
import type { ReactNode } from "react";
// override-block:imports END

// override-block:helpers BEGIN
function chipCell(value: string | null | undefined): ReactNode {
  const text = (value ?? "").toString().trim();
  if (!text) {
    return createElement("span", { style: { color: "var(--color-text-subtle)" } }, "—");
  }
  return createElement(
    "span",
    {
      style: {
        display: "inline-flex",
        alignItems: "center",
        height: 20,
        padding: "0 8px",
        fontSize: 11,
        fontWeight: 500,
        background: "var(--color-bg-subtle)",
        color: "var(--color-text-secondary)",
        border: "1px solid var(--color-border-subtle)",
        borderRadius: 9999,
        textTransform: "capitalize",
      },
    },
    text.replace(/_/g, " "),
  );
}

function widgetFamilyColumn(row: WidgetInstance): ReactNode {
  return chipCell(row.widget_family);
}

function registrationStatusColumn(row: WidgetInstance): ReactNode {
  return chipCell(row.registration_status);
}
// override-block:helpers END

export const widgetInstanceListConfig: ListPageConfig<WidgetInstance> = {
  title: "Widgets",
  subtitle: "Embeddable widgets across your sites — approve discovered placements, activate, and watch usage.",
  queryKey: ["widget-instances", "list"] as const,
  queryFn: ({ page, pageSize, sortField, sortDirection, search, filters }) =>
    widgetInstancesApi.listWidgetInstances({ page, pageSize, sortField, sortDirection, search, filters }),
  defaultSort: { field: "created_at", direction: "desc" },
  pageSize: 50,
  rowHref: "/channels/widgets/{id}",
  search: { enabled: true, placeholder: "Search widgets by name or domain…" },
  emptyState: {
    title: "No widgets yet",
    subtitle: "Widgets appear here once they are placed on your site (auto-discovered) or created here, then approved and activated.",
  },
  headerActions: [
    // override-block:header-actions BEGIN
    // override-block:header-actions END
  ],
  filterChips: [
    { id: "activation-pending", label: "Pending", field: "activation_status", value: "pending", group: "activation" },
    { id: "activation-active", label: "Active", field: "activation_status", value: "active", group: "activation" },
    { id: "activation-disabled", label: "Disabled", field: "activation_status", value: "disabled", group: "activation" },
    { id: "activation-blocked", label: "Blocked", field: "activation_status", value: "blocked", group: "activation" },
    { id: "registration-discovered", label: "Discovered", field: "registration_status", value: "discovered", group: "registration" },
    { id: "registration-pending", label: "Pending approval", field: "registration_status", value: "pending_approval", group: "registration" },
    { id: "registration-approved", label: "Approved", field: "registration_status", value: "resolved_existing", group: "registration" },
  ],
  columns: [
    { field: "display_name", label: "Widget", type: "avatar-name", sortable: true },
    { field: "widget_family", label: "Family", type: "custom", render: widgetFamilyColumn },
    { field: "activation_status", label: "Activation", type: "lifecycle-badge" },
    { field: "registration_status", label: "Registration", type: "custom", render: registrationStatusColumn },
    { field: "default_domain", label: "Domain", type: "text" },
    { field: "created_at", label: "Created", type: "datetime", sortable: true },
  ],
};
